// extracted by mini-css-extract-plugin
export default {"app":"Hpxiaq","page-container":"Bzumdc"};